import React, { useContext } from 'react'
import { Marker } from 'react-leaflet'
import MapContext from '../context/MapContex'
import { IconLocation } from './Icon'
import ModalContent from './ModalContent'

const Markers = ({ data }) => {
    const { add_data } = useContext(MapContext)
    const showPreview = (place) => {
        add_data(place)
    }
    const markers = data.map((place, i) => (


        <Marker
            key={i}
            position={{
                lat: place.latitude,
                lng: place.longitude
            }}
            icon={IconLocation}
            eventHandlers={{ click: () => showPreview(place) }}



        />
    ))
    return (
        <>
            {markers}

        </>
    )
}

export default Markers
